import React from "react";
import { InputContainer, Button } from "@networkraildigitalfactory/components";
import styles from "./Admin.module.css";

const SearchEmployee = (props) => {
  const { searchEmp, criteria, inputError, searchValue, toggleSearch, setSearchValue } = props;

  const labelText = criteria === "getEmployeeByEmpNo" ? "Employee Number" : "Email address";
  const exampleText =
    criteria === "getEmployeeByEmpNo"
      ? "For example 123456"
      : "For example Joe.Bloggs@networkrail.co.uk";
  const inputName =
    criteria === "getEmployeeByEmpNo" ? "searchEmployeeNumber" : "searchEmailAddress";
  const searchText =
    criteria === "getEmployeeByEmpNo"
      ? "Search by email address instead?"
      : "Search by employee number instead?";

  return (
    <>
      <div className={styles.searchForm}>
        <InputContainer
          required
          labelText={labelText}
          errorText={inputError}
          exampleText={exampleText}
          forLabel={inputName}
        >
          <input
            className={`${inputError ? styles.error : styles.searchTextBox}`}
            id="tabToMe"
            name={inputName}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            type="text"
            maxLength={criteria === "getEmployeeByEmpNo" ? 6 : ""}
          />
        </InputContainer>
        <div className={styles.searchSubmitButton}>
          <Button name="SearchButton" color="blue" size="sd" onClick={searchEmp} text="Search" />
        </div>
      </div>
      <div
        className={`${styles.searchInstead} ${styles.noSelect}`}
        tabIndex={0}
        role="link"
        onClick={toggleSearch}
        onKeyDown={(e) => (e.key === "Enter" ? toggleSearch() : undefined)}
      >
        {searchText}
      </div>
    </>
  );
};

export default SearchEmployee;
